import { render, staticRenderFns } from "./DisabledAccount.vue?vue&type=template&id=03c8ce2a&"
import script from "./DisabledAccount.vue?vue&type=script&lang=ts&"
export * from "./DisabledAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports